import { Component, OnInit, Input, OnChanges, SimpleChanges } from '@angular/core';
import { FormGroup, FormBuilder, FormControl, FormArray, Validators } from '@angular/forms';
import { ExistingTreatmentData } from '../request-planning-modal.component';

@Component({
  selector: 'app-request-planning-treatment-spray',
  styleUrls: ['./request-planning-treatment-spray.component.css'],
  templateUrl: './request-planning-treatment-spray.component.html'
})
export class RequestPlanningTreatmentSprayComponent implements OnInit, OnChanges {
  @Input() existingTreatmentFormData: ExistingTreatmentData;
  @Input() treatmentFormGroup: FormGroup;
  @Input() planningForm: FormGroup;
  @Input() plannedPlantingDate: Date;

  public formValue: Date;

  public get sprayBoothStudyInstructions(): FormGroup {
    return this.treatmentFormGroup.get('sprayBoothStudyInstructions') as FormGroup || this.formBuilder.group({});
  }

  public get sprayEventDaysAfterPlantingList(): FormArray {
    return this.sprayBoothStudyInstructions.get('sprayEventDaysAfterPlantingList') as FormArray;
  }

  constructor(private formBuilder: FormBuilder) { }

  ngOnInit() {
    this.buildTreatmentForm();

    const plannedPlantingDateControl = this.planningForm.get('plannedPlantingDate');
    if (plannedPlantingDateControl) {
      plannedPlantingDateControl.valueChanges.subscribe((newDate) => {
        this.formValue = newDate ? new Date(newDate) : null;
      });
    }

    this.sprayEventDaysAfterPlantingList.valueChanges.subscribe((values: number[]) => {
      values.forEach((val, idx) => {
        this.existingTreatmentFormData.sprayBoothStudyInstructions[idx].sprayEventDaysAfterPlanting = val;
      });
    });
  }


  ngOnChanges(changes: SimpleChanges) {
    if (changes.plannedPlantingDate && !changes.plannedPlantingDate.firstChange) {
      this.formValue = this.plannedPlantingDate || this.getPlannedDateFromForm();
    }
  }

  private buildTreatmentForm() {
    const controls = this.existingTreatmentFormData.sprayBoothStudyInstructions.map(
      (t) => new FormControl(t.sprayEventDaysAfterPlanting, [Validators.required, Validators.min(0)])
    );

    this.sprayBoothStudyInstructions.addControl('sprayEventDaysAfterPlantingList', new FormArray(controls));

    this.formValue = this.plannedPlantingDate || this.getPlannedDateFromForm();
  }

  private getPlannedDateFromForm(): Date {
    const plannedPlantingDate = this.planningForm.get('plannedPlantingDate').value;
    return plannedPlantingDate ? new Date(plannedPlantingDate) : null;
  }

  getFormattedDate(index: number): string {
    const control = this.sprayEventDaysAfterPlantingList.at(index);
    const daysToAdd = Number(control.value);

    if (!this.formValue || isNaN(daysToAdd) || daysToAdd === 0 || daysToAdd < 0) return '';

    const base = new Date(this.formValue);
    if (isNaN(base.getTime())) return '';

    base.setDate(base.getDate() + daysToAdd);

    const options: Intl.DateTimeFormatOptions = {
      weekday: 'long',
      year: '2-digit',
      month: '2-digit',
      day: '2-digit',
    };
    return base.toLocaleDateString('en-US', options);
  }

  collectSprayEventData(): { sprayEventNumber: number, sprayEventDaysAfterPlanting: number }[] {
    return this.sprayEventDaysAfterPlantingList.controls.map((control, index) => {
      const sprayEventNumber = this.existingTreatmentFormData.sprayBoothStudyInstructions[index].sprayEventNumber;
      const sprayEventDaysAfterPlanting = control.value;

      return { sprayEventNumber, sprayEventDaysAfterPlanting };
    });
  }
}



// WEBPACK FOOTER //
// F:/PHAZP5152IS01-2/_work/98/s/src/app/view-request/request-planning-modal/request-planning-treatment-spray/request-planning-treatment-spray.component.ts